export function emailValid(email){
    const email_regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return email_regex.test(email)
}


export function isValidEmail(email){
    email=email.trim();
    let parts = email.split("@");
    let user='';
    let domain='';
    if(parts.length>1){
        user = parts[0];
        domain = parts[1];
    }
    if(user.length > 30){
        return false;
    }

    let rx = /^[\w-]+(\.[\w-]+)*(\+[\w-]*)?@([\w-]+\.)*\w[\w-]{0,66}\.[a-z]{2,6}(\.[a-z]{2})?$/i;

    if(rx.test(email)){
        return user.split(".").length <= 4;
    }
    return false;
}
